import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { GridBooleanColumnConfig } from '../../components/paged-grid/models/grid-boolean-column.config';
import { GridColumnConfig } from '../../components/paged-grid/models/grid-column.config';
import { GridNumberColumnConfig } from '../../components/paged-grid/models/grid-number-column.config';
import { GridConfig } from '../../components/paged-grid/models/grid.config';
import { ModelTypes } from '../../core/utils/mappers/model.types';
import { UserModel } from '../../models/user.model';
import { UsersResource } from '../../services/resources/users.resource';

@Component({
    selector: 'sl-users',
    templateUrl: './users.component.html',
    styleUrls: ['./users.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class UsersComponent {
    readonly gridConfig: GridConfig<UserModel>;

    readonly usersResource = inject(UsersResource);

    constructor() {
        this.gridConfig = new GridConfig<UserModel>({
            name: 'users',
            typeName: ModelTypes.users,
            resource: this.usersResource,
            pageSize: 10,
            hasNewButton: true,
            hasEditButton: true,
            hasViewButton: true,
            hasRemoveButton: true,
            canExport: true,
            columns: [
                new GridNumberColumnConfig({ fieldName: 'id', header: 'General.Id' }),
                new GridColumnConfig({ fieldName: 'email', header: 'Contact.Email' }),
                new GridColumnConfig({ fieldName: 'firstName', header: 'Contact.FirstName' }),
                new GridColumnConfig({ fieldName: 'lastName', header: 'Contact.LastName' }),
                new GridColumnConfig({ fieldName: 'employeeNumber', header: 'Shareholders.EmployeeNumber' }),
                new GridColumnConfig({ fieldName: 'function', header: 'User.Function' }),
                new GridColumnConfig({ fieldName: 'languageId', header: 'General.Language' }),
                new GridColumnConfig({ fieldName: 'phone', header: 'User.PhoneNumber' }),
                new GridColumnConfig({ fieldName: 'mobilePhoneNumber', header: 'Contact.MobileNumber' }),
                new GridColumnConfig({ fieldName: 'windowsUser', header: 'User.WindowsUser' }),
                new GridColumnConfig({ fieldName: 'username', header: 'User.Username' }),
                new GridColumnConfig({ fieldName: 'roleName', header: 'User.RoleName' }),
                new GridBooleanColumnConfig({ fieldName: 'getsNotified', header: 'User.GetsNotified' }),
                new GridBooleanColumnConfig({ fieldName: 'approvalRight', header: 'User.ApprovalRight' })
            ]
        });
    }
}
